export interface GeoPoint {
	lat: number;
	lon: number;
	altitude?: number;
}

export interface UtahRegion {
	id: "silicon-slopes" | "slc-downtown" | "slc-west-industrial" | "ogden-corridor";
	displayName: string;
	center: GeoPoint;
	bboxKm: number;
}

export const UTAH_REGIONS: UtahRegion[] = [
	{
		id: "silicon-slopes",
		displayName: "Silicon Slopes (Lehi)",
		center: { lat: 40.391, lon: -111.851 },
		bboxKm: 6,
	},
	{
		id: "slc-downtown",
		displayName: "Salt Lake City — Downtown",
		center: { lat: 40.7608, lon: -111.891 },
		bboxKm: 4,
	},
	{
		id: "slc-west-industrial",
		displayName: "SLC — West Industrial",
		center: { lat: 40.745, lon: -111.95 },
		bboxKm: 5,
	},
	{
		id: "ogden-corridor",
		displayName: "Ogden Industrial Corridor",
		center: { lat: 41.223, lon: -111.973 },
		bboxKm: 5,
	},
];

export const DEFAULT_SPAWN: GeoPoint = UTAH_REGIONS[0]!.center;

const WGS84_A = 6378137;
const WGS84_E2 = 0.00669437999014;

export interface ECEF {
	x: number;
	y: number;
	z: number;
}

export function geodeticToEcef(p: GeoPoint): ECEF {
	const lat = (p.lat * Math.PI) / 180;
	const lon = (p.lon * Math.PI) / 180;
	const alt = p.altitude ?? 0;
	const sinLat = Math.sin(lat);
	const cosLat = Math.cos(lat);
	const sinLon = Math.sin(lon);
	const cosLon = Math.cos(lon);
	const N = WGS84_A / Math.sqrt(1 - WGS84_E2 * sinLat * sinLat);
	return {
		x: (N + alt) * cosLat * cosLon,
		y: (N + alt) * cosLat * sinLon,
		z: (N * (1 - WGS84_E2) + alt) * sinLat,
	};
}

/**
 * Row-major 3x3 rotation taking ECEF deltas to local ENU (East, North, Up)
 * at the given geodetic point.
 */
export function ecefToEnuRotation(p: GeoPoint): number[] {
	const lat = (p.lat * Math.PI) / 180;
	const lon = (p.lon * Math.PI) / 180;
	const sinLat = Math.sin(lat);
	const cosLat = Math.cos(lat);
	const sinLon = Math.sin(lon);
	const cosLon = Math.cos(lon);
	return [
		-sinLon, cosLon, 0,
		-sinLat * cosLon, -sinLat * sinLon, cosLat,
		cosLat * cosLon, cosLat * sinLon, sinLat,
	];
}
